import React, { useState, useEffect } from "react";
// ⛔ Removed Masonry imports
// import Masonry, { ResponsiveMasonry } from "react-responsive-masonry";
import LazyLoad from "react-lazyload";
import axios from "axios";
import { useNavigate, useParams } from 'react-router-dom';

const RenderNews = ({ prop }) => {
  const [newsData, setNewsData] = useState(null);
  const navigate = useNavigate();
  const { title } = useParams();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_MINF_BAC_BASE}/${prop}/${title}`);
        if (response) {
          setNewsData(response.data);
        }
      } catch (error) {
        navigate("/notfound");
        console.log(`Error fetching data: ${error.message}`);
      }
    };

    fetchData();
  }, [title, prop, navigate]);

  return (  
    <div className="w-[95%] mx-auto rounded-xl overflow-hidden">
      {newsData ? (
        <>
          {/* Hero Header Section */}
          <div className="relative w-full rounded-xl overflow-hidden">
            <div
              className="relative w-full h-[60vh] md:h-[75vh] bg-cover bg-center"
              style={{
                backgroundImage: `url(${newsData.coverimage})`,
                backgroundPosition: 'center top'
              }}
            >
              {/* Minimal Bottom Gradient Overlay */}
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent" />

              {/* Main Content - Bottom Left */}
              <div className="absolute inset-x-0 bottom-0 px-6 md:px-16 lg:px-24 pb-10">
                <div className="max-w-4xl">
                  {/* Category Badge */}
                  <div className="mb-3 inline-block">
                    <span className="text-xs md:text-sm font-semibold uppercase tracking-[0.25em] text-white/70">
                      {prop || 'Article'}
                    </span>
                  </div>

                  {/* Main Title */}
                  <h1 className="text-3xl md:text-5xl uppercase lg:text-6xl font-black text-white leading-tight tracking-tight mb-3 drop-shadow-2xl">
                    {newsData.title}
                  </h1>

                  {/* Decorative Line */}
                  <div className="h-[2px] w-16 bg-white/70 rounded-full" />
                </div>
              </div>
            </div>
          </div>

          {/* Content Section */}
          <div className="max-w-6xl mx-auto px-6 md:px-12 py-16">
            {/* Title Bar */}
            <div className="mb-12 pb-6 border-b-2 border-gray-200">
              <h2 className="text-4xl font-bold text-gray-900">
                {newsData.title}
              </h2>
              <div className="h-1 w-16 bg-gradient-to-r from-red-600 to-red-400 rounded-full mt-4" />
            </div>

            {/* First Part of Description */}
            <div className="mb-12">
              <p className="text-gray-700 leading-relaxed text-lg">
                {newsData.description.split('\n').slice(0, 2).map((paragraph, index) => (
                  <React.Fragment key={index}>
                    {paragraph}
                  </React.Fragment>
                ))}
              </p>
            </div>

            {/* Gallery Section */}
            <div className="mb-16">
              {/* Symmetrical Grid instead of Masonry */}
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
                {newsData.images.map((image, index) => (
                  <LazyLoad key={index} height={250} offset={100}>
                    <div className="relative w-full aspect-[4/3] overflow-hidden rounded-xl shadow-md transition-all duration-300">
                      <img
                        alt={`Gallery item ${index}`}
                        src={image}
                        className="w-full h-full object-cover"
                      />
                    </div>
                  </LazyLoad>
                ))}
              </div>
            </div>

            {/* Second Part of Description */}
            <div className="prose prose-lg max-w-none">
              <p className="text-gray-700 leading-relaxed text-lg">
                {newsData.description.split('\n').slice(2).map((paragraph, index) => (
                  <React.Fragment key={index}>
                    {paragraph}
                    <br />
                  </React.Fragment>
                ))}
              </p>
            </div>
          </div>
        </>
      ) : (
        <div className="min-h-screen flex items-center justify-center">
          <div className="flex flex-col items-center gap-4">
            <div className="w-12 h-12 border-4 border-gray-200 border-t-red-600 rounded-full animate-spin" />
            <p className="text-gray-600 font-medium">Loading article...</p>
          </div>
        </div>
      )}
    </div>
  );
};

export default RenderNews;
